import { render } from "./MyTopBar.vue?vue&type=template&id=32b054e2"
import script from "./MyTopBar.vue?vue&type=script&lang=js"
export * from "./MyTopBar.vue?vue&type=script&lang=js"

import exportComponent from "/home/fluffypony/Projects/cards/cards-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__